import NoneAnchor from '../../components/NoneAnchor'
import { useContext, useRef, useState } from 'react'
import ImageGuideLayer from './ImageGuideLayer'
import classNames from 'classnames'
import useOutsideClick from '../../utils/hooks/useOutsideClick'
import { ImageLibraryModalContext } from './ImageLibraryModalContext'
import { BizChannelTypes } from '../Codes'
import { GitbookLinks } from '../../utils/constants'

const ImageGuideLink = () => {
  const { type } = useContext(ImageLibraryModalContext)
  const [visible, setVisible] = useState(false)
  const layerRef = useRef()
  const linkRef = useOutsideClick(event => {
    if (layerRef.current && !layerRef.current.contains(event.target)) {
      setVisible(false)
    }
  })
  return (
    <div
      className={classNames('guide_item', {
        on: visible,
      })}>
      {type ? (
        <a
          href={
            type === BizChannelTypes.TALK_CHANNEL
              ? GitbookLinks.TALK_CHANNEL_REGISTRATION
              : GitbookLinks.PREMIUM_LINK_REGISTRATION
          }
          target="_blank"
          rel="noopener noreferrer"
          className="link_guide link_emph">
          심사 가이드
          <span className="ico_comm ico_out" />
        </a>
      ) : (
        <>
          <NoneAnchor
            ref={linkRef}
            className="link_guide link_emph"
            onClick={() => setVisible(prev => !prev)}>
            심사 가이드
            <span className="ico_comm ico_arr" />
          </NoneAnchor>
          {visible && <ImageGuideLayer ref={layerRef} />}
        </>
      )}
    </div>
  )
}
export default ImageGuideLink
